module.exports = __webpack_public_path__ + "img/flag-purple.eda12663.svg";